import notify from '../../Common/notify';
import destroyEditorData from '../../Common/destroyEditorData';
import axios from 'axios';

export default {
    namespaced: true,

    state: {
        currentFile: undefined,
        currentSrc: undefined,
        selectedFields: [],
        mediaId: '',
        tableLoading: false,
        files: [],
        deleteModal: false,
        createModal: false,
        editModal: false,
        viewModal: false,
        professions: [],
        profession: [],
        imageFields: [],
        errorMessage: undefined,
        deleteFilename: ''
    },

    getters: {
        postData(state) {
            return {
                id: state.mediaId
            };
        },

        route(state) {
            if (state.mediaId > 0) {
                return '/api/media/edit/' + state.mediaId;
            } else {
                return '/api/media/create';
            }
        }
    },

    mutations: {
        setSelectedFields(state, value) {
            state.selectedFields = value;
        },

        setDeleteFilename(state, value) {
            state.deleteFilename = value;
        },

        setCurrentSrc(state, value) {
            state.currentSrc = value;
        },

        setMediaId(state, value) {
            state.mediaId = value;
        },

        setTableLoading(state, value) {
            state.tableLoading = value;
        },

        toggleDeleteModal(state, value) {
            state.deleteModal = value;
        },

        toggleCreateModal(state, value) {
            state.createModal = value;
        },

        toggleEditModal(state, value) {
            state.editModal = value;
        },

        toggleViewModal(state, value) {
            state.viewModal = value;
        },

        setFiles(state, value) {
            state.files = value;
        },

        setCurrentFile(state, value) {
            state.currentFile = value;
        },

        setProfession(state, value) {
            state.profession = value;
        },

        setProfessions(state, value) {
            state.professions = value;
        },

        setImageFields(state, value) {
            state.imageFields = value;
        },

        setErrorMessage(state, value) {
            state.errorMessage = value;
        }
    },

    actions: {
        setMediaId({ commit }, value) {
            commit('setMediaId', value);
        },

        getImageFields({ commit }) {
            return new Promise(resolve => {
                axios.get('/api/field/index-image')
                    .then(response => {
                        commit('setImageFields', response.data.fields);
                        resolve();
                    });
            });
        },

        getProfessions({ commit }) {
            axios.get('/api/specialty/index')
                .then(response => {
                    commit('setProfessions', response.data.data.professions);
                });
        },

        getLibrary({ commit }) {
            commit('setTableLoading', true);

            axios.get('/api/media/index')
                .then(response => {
                    let fs = [];
                    const media = response.data.media;

                    media.forEach(file => {
                        file.src = this._vm.$storageURL + file.directory + '/' + file.filename + '.' + file.extension;
                        fs.push(file);
                    });

                    commit('setFiles', fs);
                    commit('setTableLoading', false);
                });
        },

        createMedia({ state, dispatch }) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('file', state.currentFile);
                formData.append('fields', JSON.stringify(state.selectedFields));
                formData.append('profession', JSON.stringify(state.profession));

                axios.post('/api/media/create',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        dispatch('getLibrary');
                        notify(response.data.message, 'success');
                        resolve();
                    })
                    .catch(() => {
                        notify('Media not uploaded: File Exists.', 'error');
                        reject();
                    });
            });
        },

        editMedia({ dispatch, commit, state }) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('fields', JSON.stringify(state.selectedFields));
                formData.append('profession', JSON.stringify(state.profession));

                axios.post('/api/media/edit/' + state.mediaId,
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        notify(response.data.message, 'success');
                        dispatch('getLibrary');
                        commit('overlay/toggleModal', false, { root: true });
                        resolve();
                    })
                    .catch(() => {
                        commit('overlay/toggleModal', false, { root: true });
                        reject();
                    });
            });
        },

        destroyData({ dispatch, state }) {
            destroyEditorData('/api/media/delete/' + state.mediaId)
                .then(() => {
                    dispatch('getLibrary');
                })
                .catch(() => {
                });
        }
    }
};
